<template>
  <li class="activity-item">
    <div :class="['activity-item__icon', `activity-item__icon--${tone}`]">
      <slot name="icon">
        <b-icon-clock-history />
      </slot>
    </div>
    <div class="activity-item__main">
      <strong>{{ title }}</strong>
      <span>{{ description }}</span>
    </div>
    <time>{{ time }}</time>
  </li>
</template>

<script>
export default {
  name: "ActivityItem",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    time: {
      type: String,
      required: true,
    },
    tone: {
      type: String,
      default: "purple",
    },
  },
};
</script>

<style scoped>
.activity-item {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  padding: 12px 0;
  list-style: none;
}

.activity-item + .activity-item {
  border-top: 1px solid #f1effa;
}

.activity-item__icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  font-size: 18px;
}

.activity-item__icon--purple {
  color: #4b20ce;
  background: #f0ebff;
}

.activity-item__icon--green {
  color: #0d9a39;
  background: #eaf8ee;
}

.activity-item__icon--blue {
  color: #215fc8;
  background: #edf3ff;
}

.activity-item__main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.activity-item__main strong {
  color: #15115e;
  font-size: 12px;
  line-height: 1.3;
}

.activity-item__main span,
.activity-item time {
  color: #706c9a;
  font-size: 11px;
  line-height: 1.3;
}

.activity-item time {
  white-space: nowrap;
}

@media screen and (max-width: 700px) {
  .activity-item {
    grid-template-columns: auto 1fr;
  }

  .activity-item time {
    grid-column: 2;
  }
}
</style>
